import { BaseApi } from './BaseApi';
export class DomainRelationshipApi extends BaseApi {
    constructor(config) {
        super(config);
    }
    getDomainChannelList(id) {
        return this.providers.makeRequest({
            route: this.buildRoute('domain/channels'),
            method: 'GET',
            params: {
                id,
            },
        });
    }
    getDomainSkillList(id) {
        return this.providers.makeRequest({
            route: this.buildRoute('domain/skills'),
            method: 'GET',
            params: {
                id,
            },
        });
    }
    getDomainMemoryList(id) {
        return this.providers.makeRequest({
            route: this.buildRoute('domain/memories'),
            method: 'GET',
            params: {
                id,
            },
        });
    }
    attachChannels(id, data) {
        return this.providers.makeRequest({
            route: this.buildRoute('domain/channels'),
            method: 'POST',
            data,
            params: {
                domainId: id,
            },
        });
    }
    attachSkills(id, data) {
        return this.providers.makeRequest({
            route: this.buildRoute('domain/skills'),
            method: 'POST',
            data,
            params: {
                domainId: id,
            },
        });
    }
    attachMemories(id, data) {
        return this.providers.makeRequest({
            route: this.buildRoute('domain/memories'),
            method: 'POST',
            data,
            params: {
                domainId: id,
            },
        });
    }
    detachChannels(id, data) {
        return this.providers.makeRequest({
            route: this.buildRoute('domain/channels'),
            method: 'DELETE',
            data,
            params: {
                domainId: id,
            },
        });
    }
    detachSkills(id, data) {
        return this.providers.makeRequest({
            route: this.buildRoute('domain/skills'),
            method: 'DELETE',
            data,
            params: {
                domainId: id,
            },
        });
    }
    detachMemories(id, data) {
        return this.providers.makeRequest({
            route: this.buildRoute('domain/memories'),
            method: 'DELETE',
            data,
            params: {
                domainId: id,
            },
        });
    }
}
//# sourceMappingURL=domainRelationshipApi.js.map